import wos from 'apis/wos';

import type { SavedArrangement, SavedArrangementPOSTData } from 'domains/saved_arrangements';

export const all = async () => {
  const response = await wos.get<SavedArrangement[]>('/arrangements.json');
  return response.data;
};

export const find = async (id: number) => {
  const response = await wos.get<SavedArrangement>(`/arrangements/${id}.json`);
  return response.data;
};

export const create = async (data: SavedArrangementPOSTData) => {
  const response = await wos.post<SavedArrangement>('/arrangements.json', {
    arrangement: data,
  });
  return response.data;
};

export const update = async (id: number, data: SavedArrangementPOSTData) => {
  const response = await wos.put<SavedArrangement>(`/arrangements/${id}.json`, {
    arrangement: data,
  });
  return response.data;
};

export const destroy = async (id: number) => {
  await wos.delete(`/arrangements/${id}.json`);
};

export const fromUploads = async (ids: number[]) => {
  const response = await wos.get<SavedArrangement[]>('/arrangements/from_uploads', {
    params: { ids },
  });
  return response.data;
};
